__turbopack_context__.v({
  "body": "xNTbFa_body",
  "closeButton": "xNTbFa_closeButton",
  "description": "xNTbFa_description",
  "icon": "xNTbFa_icon",
  "root": "xNTbFa_root",
  "title": "xNTbFa_title",
});
